import { createBrowserRouter } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { RequireAuth } from './RequireAuth'
import { AppLayout } from './AppLayout'
import { Login } from '../features/auth/Login'
import { Dashboard } from '../features/trips/Dashboard'
import { CreateTripPicker } from '../features/trips/CreateTripPicker'
import { CreateTripManual } from '../features/trips/CreateTripManual'
import { CreateTripAi } from '../features/trips/CreateTripAi'
import { CreateTripFromTemplate } from '../features/trips/CreateTripFromTemplate'
import { TripOverview } from '../features/trips/TripOverview'
import { Places } from '../features/trips/Places'
import { Timeline } from '../features/timeline/Timeline'
import { PointDetail } from '../features/timeline/PointDetail'
import { MapView } from '../features/map/MapView'
import { LiveMode } from '../features/live/LiveMode'
import { MediaLibrary } from '../features/media/MediaLibrary'
import { DocumentsLibrary } from '../features/documents/DocumentsLibrary'
import { People } from '../features/people/People'
import { JoinTrip } from '../features/people/JoinTrip'
import { AiPanel } from '../features/ai/AiPanel'
import { ExportTrip } from '../features/export/ExportTrip'
import { Budget } from '../features/budget/Budget'
import { LinksTab } from '../features/links/LinksTab'
import { MarketplacePage } from '../features/marketplace/MarketplacePage'
import { Settings } from '../features/settings/Settings'
import { Welcome } from '../features/misc/Welcome'
import { NotFound } from '../features/misc/NotFound'
const StoryPage = lazy(() => import('../features/story/StoryPage'))

export const router = createBrowserRouter([
  { path: '/welcome', element: <Welcome /> },
  { path: '/login', element: <Login /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <Dashboard /> },
          { path: 'settings', element: <Settings /> },
          { path: 'join/:token', element: <JoinTrip /> },
          { path: 'trips/new', element: <CreateTripPicker /> },
          { path: 'trips/new/manual', element: <CreateTripManual /> },
          { path: 'trips/new/ai', element: <CreateTripAi /> },
          { path: 'trips/new/template/:template', element: <CreateTripFromTemplate /> },
          { path: 'trips/:id', element: <TripOverview /> },
          { path: 'trips/:id/timeline', element: <Timeline /> },
          { path: 'trips/:id/places', element: <Places /> },
          { path: 'trips/:id/points/:pointId', element: <PointDetail /> },
          { path: 'trips/:id/map', element: <MapView /> },
          { path: 'trips/:id/media', element: <MediaLibrary /> },
          { path: 'trips/:id/documents', element: <DocumentsLibrary /> },
          { path: 'trips/:id/people', element: <People /> },
          { path: 'trips/:id/links', element: <LinksTab /> },
          { path: 'trips/:id/marketplace', element: <MarketplacePage /> },
          { path: 'trips/:id/ai', element: <AiPanel /> },
          { path: 'trips/:id/export', element: <ExportTrip /> },
          { path: 'trips/:id/budget', element: <Budget /> },
          { path: 'trips/:id/live', element: <LiveMode /> },
        ],
      },
    ],
  },
  { path: '*', element: <NotFound /> },
  { path: 'story/:slug', element: <Suspense fallback={null}><StoryPage /></Suspense> },
])
